(function () {

/* Mobile gallery dots and autoplay */
(function () {
  const gallery = document.querySelector('.page-purchase .gallery-main');
  if (!gallery || gallery.dataset.mobileDotsReady === 'true') return;
  const thumbs = Array.from(gallery.querySelectorAll('.gallery-thumb'));
  if (thumbs.length < 2) return;
  gallery.dataset.mobileDotsReady = 'true';
  const dots = document.createElement('div');
  dots.className = 'gallery-mobile-dots';
  dots.setAttribute('aria-label', 'Product image pages');
  const updateDots = () => {
    const activeIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('active')));
    dots.querySelectorAll('button').forEach((dot, index) => {
      const active = index === activeIndex;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-current', active ? 'true' : 'false');
    });
  };
  let autoplayTimer = null;
  const stopAutoplay = () => { if (autoplayTimer) window.clearInterval(autoplayTimer); autoplayTimer = null; };
  const startAutoplay = () => {
    stopAutoplay();
    if (!window.matchMedia('(max-width: 749px)').matches || document.hidden) return;
    autoplayTimer = window.setInterval(() => {
      let current = thumbs.findIndex((thumb) => thumb.classList.contains('active'));
      if (current < 0) current = 0;
      thumbs[(current + 1) % thumbs.length].click();
    }, 4500);
  };
  const restartAutoplay = () => { stopAutoplay(); window.setTimeout(startAutoplay, 4500); };
  thumbs.forEach((thumb, index) => {
    const dot = document.createElement('button');
    dot.type = 'button';
    dot.className = 'gallery-mobile-dot';
    dot.setAttribute('aria-label', 'Show product image ' + (index + 1));
    dot.addEventListener('click', () => { thumb.click(); restartAutoplay(); });
    dots.appendChild(dot);
  });
  gallery.appendChild(dots);
  const observer = new MutationObserver(updateDots);
  thumbs.forEach((thumb) => observer.observe(thumb, { attributes: true, attributeFilter: ['class'] }));
  gallery.addEventListener('touchstart', stopAutoplay, { passive: true });
  gallery.addEventListener('touchend', restartAutoplay, { passive: true });
  gallery.addEventListener('pointerdown', stopAutoplay);
  gallery.addEventListener('pointerup', restartAutoplay);
  document.addEventListener('visibilitychange', () => document.hidden ? stopAutoplay() : startAutoplay());
  window.addEventListener('resize', startAutoplay);
  updateDots();
  startAutoplay();
})();
(function () {
  const style = document.createElement('style');
  style.textContent = '@media (max-width: 749px) {' +
    '.page-purchase .gallery-main::after{content:none!important;display:none!important;}' +
    '.page-purchase .gallery-mobile-nav{display:none!important;}' +
    '.page-purchase .gallery-mobile-dots{position:absolute;left:50%;bottom:12px;z-index:7;display:flex;align-items:center;justify-content:center;gap:7px;transform:translateX(-50%);}' +
    '.page-purchase .gallery-mobile-dot{display:block;width:8px;height:8px;min-width:8px;padding:0;border:0;border-radius:50%;background:rgba(22,27,37,.28);box-shadow:0 0 0 1px rgba(255,255,255,.55);transition:background-color .2s ease,transform .2s ease;}' +
    '.page-purchase .gallery-mobile-dot.is-active{background:#d8ff3e;box-shadow:0 0 0 1px rgba(17,24,39,.42);transform:scale(1.18);}' +
  '}@media (min-width: 750px){.gallery-mobile-dots{display:none!important;}}';
  document.head.appendChild(style);
})();

  'use strict';

  const productData = window.PettiChatProduct;
  const UNIT_PRICE = productData && productData.variants && productData.variants.length
    ? productData.variants.find(function (v) { return v.id === productData.selectedVariantId; })?.price / 100
    : 119.99;

  /* ── Mobile nav ── */
  const navToggle = document.getElementById('navToggle');
  const navLinks = document.getElementById('navLinks');
  if (navToggle && navLinks) {
    const closeMobileNav = () => {
      navLinks.classList.remove('is-open');
      navToggle.classList.remove('is-open');
      navToggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('nav-open', 'menu-open');
    };

    navToggle.addEventListener('click', () => {
      const isOpen = navLinks.classList.toggle('is-open');
      navToggle.classList.toggle('is-open', isOpen);
      navToggle.setAttribute('aria-expanded', String(isOpen));
    });

    navLinks.addEventListener('click', (event) => {
      const link = event.target.closest('a');
      if (!link) return;
      closeMobileNav();
    });
  }

  /* ── FAQ hover reveal (aria-expanded for screen readers) ── */
  document.querySelectorAll('.faq-item').forEach((item) => {
    const btn = item.querySelector('.faq-question');
    if (!btn) return;

    const setExpanded = (expanded) => btn.setAttribute('aria-expanded', String(expanded));

    item.addEventListener('mouseenter', () => setExpanded(true));
    item.addEventListener('mouseleave', () => setExpanded(false));
    item.addEventListener('focusin', () => setExpanded(true));
    item.addEventListener('focusout', (e) => {
      if (!item.contains(e.relatedTarget)) setExpanded(false);
    });
  });

  /* ── Product gallery ── */
  const mainImage = document.getElementById('mainImage');
  const galleryThumbs = Array.from(document.querySelectorAll('.gallery-thumb'));
  const galleryPrev = document.querySelector('.gallery-mobile-arrow--prev');
  const galleryNext = document.querySelector('.gallery-mobile-arrow--next');
  galleryThumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const src = thumb.dataset.src;
      if (!src || !mainImage) return;
      mainImage.src = src;
      document.querySelectorAll('.gallery-thumb').forEach((t) => {
        t.classList.remove('active');
        t.setAttribute('aria-pressed', 'false');
      });
      thumb.classList.add('active');
      thumb.setAttribute('aria-pressed', 'true');
    });
  });
  function moveGallery(direction) {
    if (!galleryThumbs.length) return;
    let current = galleryThumbs.findIndex((thumb) => thumb.classList.contains('active'));
    if (current < 0) current = 0;
    galleryThumbs[(current + direction + galleryThumbs.length) % galleryThumbs.length].click();
  }
  if (galleryPrev) galleryPrev.addEventListener('click', () => moveGallery(-1));
  if (galleryNext) galleryNext.addEventListener('click', () => moveGallery(1));

  const galleryMain = mainImage && mainImage.closest('.gallery-main');
  if (galleryMain) {
    let galleryTouchStartX = 0;
    let galleryTouchStartY = 0;

    galleryMain.addEventListener('touchstart', (event) => {
      if (event.touches.length !== 1) return;
      galleryTouchStartX = event.touches[0].clientX;
      galleryTouchStartY = event.touches[0].clientY;
    }, { passive: true });

    galleryMain.addEventListener('touchend', (event) => {
      if (!event.changedTouches.length) return;
      const deltaX = event.changedTouches[0].clientX - galleryTouchStartX;
      const deltaY = event.changedTouches[0].clientY - galleryTouchStartY;
      if (Math.abs(deltaX) < 40 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
      moveGallery(deltaX < 0 ? 1 : -1);
      
    }, { passive: true });
  }

  /* ── Quantity selector ── */
  const qtyValue = document.getElementById('qtyValue');
  const qtyInput = document.getElementById('qtyInput');
  const qtyMinus = document.getElementById('qtyMinus');
  const qtyPlus = document.getElementById('qtyPlus');
  const checkoutBtn = document.getElementById('checkoutBtn');
  const mobileCheckoutBtn = document.querySelector('.gallery-mobile-buy');
  const addToCartBtn = document.getElementById('addToCartBtn');
  const productPrice = document.getElementById('productPrice');
  const productComparePrice = document.getElementById('productComparePrice');
  const mobileProductPrice = document.getElementById('mobileProductPrice');
  const mobileProductComparePrice = document.getElementById('mobileProductComparePrice');
  const variantSelect = document.getElementById('variant-select');
  const variantInputs = Array.from(document.querySelectorAll('[data-variant-input]'));
  const selectedVariantLabel = document.querySelector('[data-selected-variant]');
  const productForm = document.getElementById('product-form');
  const productFormStatus = document.getElementById('productFormStatus');
  let qty = 1;
  let unitPriceCents = productData && productData.variants
    ? (productData.variants.find(function (v) { return v.id === productData.selectedVariantId; }) || productData.variants[0]).price
    : Math.round(UNIT_PRICE * 100);

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, (window.PettiChat && window.PettiChat.moneyFormat) || '${{amount}}');
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function getSelectedVariant() {
    if (!productData || !productData.variants) return null;
    const checkedVariant = variantInputs.find(function (input) { return input.checked; });
    const id = checkedVariant
      ? parseInt(checkedVariant.value, 10)
      : variantSelect
        ? parseInt(variantSelect.value, 10)
        : productData.selectedVariantId;
    return productData.variants.find(function (v) { return v.id === id; }) || productData.variants[0];
  }

  function updateQty() {
    if (qtyValue) qtyValue.textContent = String(qty);
    if (qtyInput) qtyInput.value = String(qty);
    const variant = getSelectedVariant();
    if (variant) unitPriceCents = variant.price;
    if (variant && productPrice && productPrice.dataset.nativePrice === 'true') {
      productPrice.textContent = formatMoney(variant.price);
    }
    if (variant && productComparePrice && productComparePrice.dataset.nativePrice === 'true') {
      productComparePrice.textContent = variant.compare_at_price && variant.compare_at_price > variant.price
        ? formatMoney(variant.compare_at_price)
        : '';
      productComparePrice.hidden = !(variant.compare_at_price && variant.compare_at_price > variant.price);
    }
    if (variant && mobileProductPrice && mobileProductPrice.dataset.nativePrice === 'true') {
      mobileProductPrice.textContent = formatMoney(variant.price);
    }
    if (variant && mobileProductComparePrice && mobileProductComparePrice.dataset.nativePrice === 'true') {
      mobileProductComparePrice.textContent = variant.compare_at_price && variant.compare_at_price > variant.price
        ? formatMoney(variant.compare_at_price)
        : '';
      mobileProductComparePrice.hidden = !(variant.compare_at_price && variant.compare_at_price > variant.price);
    }
    if (checkoutBtn && variant) {
      checkoutBtn.textContent = variant.available
        ? (checkoutBtn.dataset.availableLabel || 'Buy Now !')
        : (checkoutBtn.dataset.soldOutLabel || 'Sold Out');
    }
    if (mobileCheckoutBtn && variant) {
      mobileCheckoutBtn.textContent = variant.available
        ? (mobileCheckoutBtn.dataset.availableLabel || 'Buy Now !')
        : (mobileCheckoutBtn.dataset.soldOutLabel || 'Sold Out');
    }
    if (addToCartBtn && variant) {
      addToCartBtn.textContent = variant.available
        ? (addToCartBtn.dataset.availableLabel || 'Add to Cart')
        : (addToCartBtn.dataset.soldOutLabel || 'Sold Out');
    }
  }

  function handleVariantChange(event) {
      const variant = getSelectedVariant();
      if (!variant) return;
      unitPriceCents = variant.price;
      if (checkoutBtn) checkoutBtn.disabled = !variant.available;
      if (mobileCheckoutBtn) mobileCheckoutBtn.disabled = !variant.available;
      if (addToCartBtn) addToCartBtn.disabled = !variant.available;
      if (selectedVariantLabel) selectedVariantLabel.textContent = variant.title;
      if (mainImage && event && event.currentTarget && event.currentTarget.dataset.variantImage) {
        const physicalThumb = galleryThumbs.find(function (thumb) {
          return thumb.dataset.galleryVariantId === String(variant.id) && thumb.dataset.galleryImageKind === 'physical';
        });
        if (physicalThumb) {
          physicalThumb.click();
        } else {
          mainImage.src = event.currentTarget.dataset.variantImage;
        }
      }
      if (window.history && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(variant.id));
        window.history.replaceState({}, '', url.toString());
      }
      if (productFormStatus) productFormStatus.textContent = '';
      if (window.PettiChat && typeof window.PettiChat.publish === 'function') {
        window.PettiChat.publish('pettichat_variant_selected', {
          product_id: productData.productId,
          variant_id: variant.id,
          value: variant.price / 100,
          currency: window.Shopify && Shopify.currency ? Shopify.currency.active : undefined
        });
      }
      updateQty();
  }

  if (variantSelect) variantSelect.addEventListener('change', handleVariantChange);
  variantInputs.forEach(function (input) {
    input.addEventListener('change', handleVariantChange);
  });

  if (qtyMinus) {
    qtyMinus.addEventListener('click', () => {
      if (qty > 1) { qty--; updateQty(); }
    });
  }
  if (qtyPlus) {
    qtyPlus.addEventListener('click', () => {
      if (qty < 99) { qty++; updateQty(); }
    });
  }

  function addVariantToCart(variant) {
    const routes = (window.PettiChat && window.PettiChat.routes) || {};
    const data = new FormData(productForm);
    data.set('id', String(variant.id));
    data.set('quantity', String(qty));
    return fetch((routes.cartAdd || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: data,
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (payload) {
        if (!res.ok) throw new Error(payload.description || payload.message || 'Cart add failed');
        return payload;
      });
    });
  }

  function getCartJson() {
    return fetch('/cart.js', {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
    }).then(function (res) {
      if (!res.ok) throw new Error('Cart refresh failed');
      return res.json();
    });
  }

  function updateHeaderCartCount(cart) {
    if (!cart || typeof cart.item_count === 'undefined') return;
    document.querySelectorAll('.nav-cart').forEach(function (cartLink) {
      let bubble = cartLink.querySelector('.nav-cart__count');
      if (cart.item_count > 0) {
        if (!bubble) {
          bubble = document.createElement('span');
          bubble.className = 'nav-cart__count';
          cartLink.appendChild(bubble);
        }
        bubble.textContent = String(cart.item_count);
        bubble.setAttribute('aria-label', cart.item_count + ' items in cart');
      } else if (bubble) {
        bubble.remove();
      }
    });
  }

  function playAddToCartFlyAnimation(sourceEl) {
    const target = document.querySelector('.nav-cart, #cart-icon-bubble, [href="/cart"]');
    if (!sourceEl || !target) return;
    const sourceRect = sourceEl.getBoundingClientRect();
    const targetRect = target.getBoundingClientRect();
    if (!sourceRect.width || !targetRect.width) return;

    const fly = document.createElement('span');
    fly.className = 'cart-fly-effect';
    fly.setAttribute('aria-hidden', 'true');
    fly.style.left = (sourceRect.left + sourceRect.width / 2) + 'px';
    fly.style.top = (sourceRect.top + sourceRect.height / 2) + 'px';
    fly.style.setProperty('--cart-fly-x', (targetRect.left + targetRect.width / 2 - sourceRect.left - sourceRect.width / 2) + 'px');
    fly.style.setProperty('--cart-fly-y', (targetRect.top + targetRect.height / 2 - sourceRect.top - sourceRect.height / 2) + 'px');
    document.body.appendChild(fly);

    target.classList.add('cart-fly-target-pulse');
    fly.addEventListener('animationend', function () {
      fly.remove();
      window.setTimeout(function () {
        target.classList.remove('cart-fly-target-pulse');
      }, 180);
    }, { once: true });
  }

  function submitNativeFallback(destination) {
    if (!productForm) return;
    let returnTo = productForm.querySelector('input[name="return_to"]');
    if (!returnTo) {
      returnTo = document.createElement('input');
      returnTo.type = 'hidden';
      returnTo.name = 'return_to';
      productForm.appendChild(returnTo);
    }
    returnTo.value = destination;
    productForm.submit();
  }

  if (productForm) {
    updateQty();

    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const variant = getSelectedVariant();
      if (!variant || !variant.available) return;
      const submitter = e.submitter || checkoutBtn;
      const action = submitter && submitter.dataset.cartAction === 'checkout' ? 'checkout' : 'cart';
      const routes = (window.PettiChat && window.PettiChat.routes) || {};
      const destination = routes.cart || '/cart';

      if (checkoutBtn) checkoutBtn.disabled = true;
      if (mobileCheckoutBtn) mobileCheckoutBtn.disabled = true;
      if (addToCartBtn) addToCartBtn.disabled = true;
      if (productFormStatus) productFormStatus.textContent = action === 'checkout' ? 'Preparing cart…' : 'Adding to cart…';

      addVariantToCart(variant)
        .then(function (item) {
          if (window.PettiChat && typeof window.PettiChat.publish === 'function') {
            window.PettiChat.publish(action === 'checkout' ? 'pettichat_buy_now_to_cart' : 'pettichat_cart_added', {
              product_id: productData.productId,
              variant_id: item.variant_id || variant.id,
              quantity: qty,
              value: (variant.price * qty) / 100,
              currency: window.Shopify && Shopify.currency ? Shopify.currency.active : undefined
            });
          }
          if (action === 'checkout') {
            window.location.assign(destination);
            return null;
          }
          playAddToCartFlyAnimation(submitter || addToCartBtn);
          if (productFormStatus) productFormStatus.textContent = addToCartBtn && addToCartBtn.dataset.addedLabel ? addToCartBtn.dataset.addedLabel : 'Added to cart';
          return getCartJson().then(updateHeaderCartCount).catch(function () {});
        })
        .then(function () {
          if (action === 'cart') {
            if (checkoutBtn) checkoutBtn.disabled = false;
            if (mobileCheckoutBtn) mobileCheckoutBtn.disabled = false;
            if (addToCartBtn) addToCartBtn.disabled = false;
            window.setTimeout(function () {
              if (productFormStatus) productFormStatus.textContent = '';
            }, 1600);
          }
        })
        .catch(function (error) {
          if (productFormStatus) productFormStatus.textContent = error.message || 'Unable to add this item. Trying the native cart…';
          if (checkoutBtn) checkoutBtn.disabled = false;
          if (mobileCheckoutBtn) mobileCheckoutBtn.disabled = false;
          if (addToCartBtn) addToCartBtn.disabled = false;
          submitNativeFallback(destination);
        });
    });
  }

  if (productData && window.PettiChat && typeof window.PettiChat.publish === 'function') {
    window.PettiChat.publish('pettichat_product_viewed', {
      product_id: productData.productId,
      product_title: productData.productTitle,
      variant_id: productData.selectedVariantId,
      url: productData.productUrl
    });
  }

  /* ── Animated counters ── */
  function animateCounter(el) {
    if (el.classList.contains('is-counted')) return;
    const target = parseInt(el.dataset.count, 10);
    if (!target || isNaN(target)) return;
    if (!el.hasAttribute('data-orig')) {
      el.setAttribute('data-orig', el.textContent.trim());
    }
    const orig = el.getAttribute('data-orig');
    const numEl = el.querySelector('.stat-num');
    const duration = 1500;
    const start = performance.now();

    function formatValue(n) {
      if (orig.includes('M')) {
        let val = (n / 1000000).toFixed(1) + 'M';
        if (orig.includes('+')) val += '+';
        return val;
      }
      if (orig.includes('K')) {
        let val = Math.round(n / 1000) + 'K';
        if (orig.includes('+')) val += '+';
        return val;
      }
      if (orig.includes('%')) return Math.round(n) + '%';
      if (orig.includes('+')) return Math.round(n) + '+';
      if (orig.includes('.') && target < 1000) {
        return n.toFixed(1) + orig.replace(/[\d.]/g, '');
      }
      return String(Math.round(n));
    }

    function extractNum(formatted) {
      const match = formatted.match(/^\+?([\d.,]+)/);
      return match ? match[1] : formatted;
    }

    function tick(now) {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const formatted = formatValue(target * eased);
      if (numEl) {
        numEl.textContent = extractNum(formatted);
      } else {
        el.textContent = formatted;
      }
      if (progress < 1) {
        requestAnimationFrame(tick);
      } else {
        el.classList.add('is-counted');
      }
    }

    requestAnimationFrame(tick);
  }

  /* ── Scroll reveal (fade / slide / stagger) ── */
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealElement(el) {
    el.classList.add('is-visible');
  }

  /** Defer is-visible until after paint so CSS transitions run. */
  function revealAfterPaint(el) {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => revealElement(el));
    });
  }

  /** Remove is-visible and force reflow so transitions replay on re-enter. */
  function hideElement(el) {
    el.classList.remove('is-visible');
    void el.offsetWidth;
  }

  /* ── App showcase: scroll-driven 3-state page flip ── */
  function initAppShowcaseFlip() {
    const root = document.querySelector('[data-app-showcase]');
    if (!root) return;

    const states = Array.from(root.querySelectorAll('.app-showcase-state'));
    const desktopScreens = Array.from(root.querySelectorAll('.app-showcase-phone-desktop .app-showcase-screen'));
    const mobileScreens = Array.from(root.querySelectorAll('.app-showcase-phone-mobile .app-showcase-screen'));
    const dots = Array.from(root.querySelectorAll('.app-showcase-dot'));
    const copyEl = root.querySelector('.app-showcase-copy');
    const stickyEl = root.querySelector('.app-showcase-sticky');
    const navEl = document.querySelector('.site-nav');
    const MAP_STATE_INDEX = 2;
    const stateCount = states.length;
    if (!stateCount) return;

    const desktopMq = window.matchMedia('(min-width: 1025px)');
    const reducedMq = window.matchMedia('(prefers-reduced-motion: reduce)');
    const MOBILE_CAROUSEL_MS = 4500;

    let activeIndex = 0;
    let removeScrollListeners = null;
    let carouselTimer = null;
    let carouselResumeTimer = null;

    function isDesktop() {
      return desktopMq.matches;
    }

    function getActiveScreens() {
      return isDesktop() ? desktopScreens : mobileScreens;
    }

    function useScrollMode() {
      if (reducedMq.matches) return false;
      if (isDesktop()) return true;
      const scrollable = root.offsetHeight - window.innerHeight;
      return scrollable > 64;
    }

    function preloadShowcaseScreens() {
      getActiveScreens().forEach((img) => {
        if (!img.src || img.complete) return;
        const preload = new Image();
        preload.src = img.currentSrc || img.src;
      });
    }

    function stopMobileCarousel() {
      if (carouselTimer) {
        clearInterval(carouselTimer);
        carouselTimer = null;
      }
      if (carouselResumeTimer) {
        clearTimeout(carouselResumeTimer);
        carouselResumeTimer = null;
      }
    }

    function startMobileCarousel() {
      stopMobileCarousel();
      if (useScrollMode() || reducedMq.matches || stateCount <= 1) return;
      carouselTimer = setInterval(() => {
        goToState((activeIndex + 1) % stateCount);
      }, MOBILE_CAROUSEL_MS);
    }

    function pauseMobileCarousel(ms) {
      stopMobileCarousel();
      if (useScrollMode() || reducedMq.matches) return;
      carouselResumeTimer = setTimeout(startMobileCarousel, ms);
    }

    const TRANSITION_WIDTH = 0.10;

    /** Quint ease-in-out — softer crossfade than smoothstep */
    function showcaseEase(t) {
      const x = Math.max(0, Math.min(1, t));
      return x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2;
    }

    function syncShowcaseStickyMetrics() {
      const navH = navEl ? navEl.offsetHeight : 80;
      root.style.setProperty('--showcase-sticky-top', `${navH}px`);
      root.style.setProperty('--showcase-sticky-height', `calc(100dvh - ${navH}px)`);
    }

    function syncStickyBackground(opacities) {
      if (!stickyEl) return;
      if (!isDesktop()) {
        stickyEl.style.removeProperty('background-color');
        return;
      }
      const darkWeight = Math.round((opacities[0] ?? 0) * 100);
      stickyEl.style.backgroundColor = `color-mix(in srgb, #1a1a1a ${darkWeight}%, #ffffff)`;
    }

    /** Opacity per state with hold zones at 0 / 0.5 / 1 and eased crossfades between. */
    function computeHoldOpacities(progress) {
      const opacities = new Array(stateCount).fill(0);
      const p = Math.max(0, Math.min(1, progress));

      if (stateCount <= 1) {
        opacities[0] = 1;
        return opacities;
      }

      for (let i = 0; i < stateCount - 1; i++) {
        const a = i / (stateCount - 1);
        const b = (i + 1) / (stateCount - 1);
        const mid = (a + b) / 2;
        const holdBefore = mid - TRANSITION_WIDTH / 2;
        const holdAfter = mid + TRANSITION_WIDTH / 2;

        if (p >= a && p <= b) {
          if (p <= holdBefore) {
            opacities[i] = 1;
          } else if (p >= holdAfter) {
            opacities[i + 1] = 1;
          } else {
            const t = (p - holdBefore) / TRANSITION_WIDTH;
            const eased = showcaseEase(t);
            opacities[i] = 1 - eased;
            opacities[i + 1] = eased;
          }
          return opacities;
        }
      }

      if (p <= 0) opacities[0] = 1;
      if (p >= 1) opacities[stateCount - 1] = 1;
      return opacities;
    }

    function applyLayerOpacity(elements, opacities) {
      const scrollMode = useScrollMode();
      elements.forEach((el, i) => {
        const opacity = opacities[i] ?? 0;
        el.style.opacity = String(opacity);
        const shouldShow = opacity > 0.01;
        if (scrollMode || !isDesktop()) {
          el.style.visibility = shouldShow ? 'visible' : 'hidden';
        } else {
          el.style.removeProperty('visibility');
        }
        el.style.zIndex = shouldShow ? String(i + 1) : '0';
      });
    }

    function applyScreenOpacities(opacities) {
      mobileScreens.forEach((img) => {
        const idx = Number(img.getAttribute('data-screen'));
        const opacity = Number.isNaN(idx) ? 0 : (opacities[idx] ?? 0);
        img.style.opacity = String(opacity);
        img.style.visibility = opacity > 0.01 ? 'visible' : 'hidden';
        img.style.zIndex = opacity > 0.01 ? String(idx + 1) : '0';
      });
    }

    function applyProgress(progress) {
      const opacities = computeHoldOpacities(progress);
      applyLayerOpacity(states, opacities);
      if (isDesktop()) {
        applyLayerOpacity(desktopScreens, opacities);
      } else {
        applyScreenOpacities(opacities);
      }
      syncStickyBackground(opacities);

      if (copyEl) {
        const useDarkCopy = (opacities[MAP_STATE_INDEX] ?? 0) > 0.45;
        copyEl.classList.toggle('app-showcase-copy--dark', useDarkCopy);
        copyEl.classList.toggle('app-showcase-copy--light', !useDarkCopy);
        if (!isDesktop()) {
          copyEl.style.removeProperty('opacity');
          copyEl.style.visibility = 'visible';
        } else {
          copyEl.style.removeProperty('opacity');
          copyEl.style.removeProperty('visibility');
        }
      }

      let nextIndex = 0;
      let maxOpacity = 0;
      opacities.forEach((opacity, i) => {
        if (opacity > maxOpacity) {
          maxOpacity = opacity;
          nextIndex = i;
        }
      });

      if (nextIndex !== activeIndex) {
        activeIndex = nextIndex;
        dots.forEach((dot, i) => {
          const isActive = i === activeIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        root.setAttribute('data-active-state', String(activeIndex));
      }
    }

    function getScrollProgress() {
      const scrollable = root.offsetHeight - window.innerHeight;
      if (scrollable <= 0) return 0;
      const rect = root.getBoundingClientRect();
      return Math.max(0, Math.min(1, -rect.top / scrollable));
    }

    function progressForState(index) {
      return stateCount > 1 ? index / (stateCount - 1) : 0;
    }

    function syncProgress() {
      if (useScrollMode()) {
        applyProgress(getScrollProgress());
      } else {
        applyProgress(progressForState(activeIndex));
      }
    }

    function goToState(index) {
      const target = Math.max(0, Math.min(stateCount - 1, index));
      if (useScrollMode()) {
        const scrollable = root.offsetHeight - window.innerHeight;
        if (scrollable <= 0) {
          applyProgress(progressForState(target));
          return;
        }
        const sectionTop = root.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
          top: sectionTop + progressForState(target) * scrollable,
          behavior: reducedMq.matches ? 'auto' : 'smooth',
        });
      } else {
        activeIndex = target;
        dots.forEach((dot, i) => {
          const isActive = i === target;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        root.setAttribute('data-active-state', String(target));
        applyProgress(progressForState(target));
      }
    }

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = Number(dot.getAttribute('data-goto'));
        if (!Number.isNaN(index)) {
          goToState(index);
          pauseMobileCarousel(MOBILE_CAROUSEL_MS * 2);
        }
      });
    });

    function setMode() {
      const useScroll = useScrollMode();
      root.classList.toggle('is-reduced-motion', !useScroll);
      root.classList.toggle('is-mobile-carousel', !useScroll);

      if (removeScrollListeners) {
        removeScrollListeners();
        removeScrollListeners = null;
      }
      stopMobileCarousel();

      if (useScroll) {
        let ticking = false;
        const onScroll = () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            applyProgress(getScrollProgress());
            ticking = false;
          });
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        window.addEventListener('resize', syncShowcaseStickyMetrics, { passive: true });
        removeScrollListeners = () => {
          window.removeEventListener('scroll', onScroll);
          window.removeEventListener('resize', onScroll);
          window.removeEventListener('resize', syncShowcaseStickyMetrics);
        };
        syncShowcaseStickyMetrics();
        syncProgress();
      } else {
        syncProgress();
        startMobileCarousel();
      }
    }

    const showcaseObs = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          preloadShowcaseScreens();
          if (!useScrollMode() && !reducedMq.matches) startMobileCarousel();
        } else {
          stopMobileCarousel();
        }
      });
    }, { threshold: 0.15 });
    showcaseObs.observe(root);

    reducedMq.addEventListener('change', setMode);
    desktopMq.addEventListener('change', setMode);
    window.addEventListener('load', syncProgress);
    window.addEventListener('pageshow', syncProgress);
    window.addEventListener('hashchange', syncProgress);
    window.addEventListener('load', syncShowcaseStickyMetrics);
    window.addEventListener('resize', syncShowcaseStickyMetrics);
    root.setAttribute('data-active-state', '0');
    preloadShowcaseScreens();
    root.classList.add('is-initialized');
    syncShowcaseStickyMetrics();
    setMode();
    requestAnimationFrame(() => requestAnimationFrame(syncProgress));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAppShowcaseFlip);
  } else {
    initAppShowcaseFlip();
  }

  function initScrollReveal() {
    const revealEls = Array.from(document.querySelectorAll('.reveal, .reveal-stagger'));
    if (!revealEls.length) return;

    if (prefersReducedMotion) {
      revealEls.forEach(revealElement);
      return;
    }

    const revealObs = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          revealAfterPaint(entry.target);
          revealObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -4% 0px' });

    revealEls.forEach((el) => {
      const rect = el.getBoundingClientRect();
      const inView = rect.top < window.innerHeight * 0.94 && rect.bottom > 0;
      if (inView) {
        revealAfterPaint(el);
      } else {
        revealObs.observe(el);
      }
    });
  }

  /* Shopify replaces section HTML after an editor setting changes. Newly
     inserted reveal nodes are not observed by the initial page observer, so
     keep them visible while editing instead of leaving the section transparent. */
  document.addEventListener('shopify:section:load', (event) => {
    if (!event.target) return;
    event.target.querySelectorAll('.reveal, .reveal-stagger').forEach(revealElement);
    if (event.target.querySelector('.section-usage')) initUsageVideos(event.target);
  });

  /** Subtle hero background parallax on scroll (desktop only — mobile uses Figma crop) */
  function initHeroParallax() {
    if (prefersReducedMotion) return;
    if (window.matchMedia('(max-width: 640px)').matches) return;

    const hero = document.querySelector('.hero');
    const heroMedia = document.querySelector('.hero-bg video, .hero-bg img');
    if (!hero || !heroMedia) return;

    let ticking = false;

    function update() {
      const rect = hero.getBoundingClientRect();
      if (rect.bottom > 0 && rect.top < window.innerHeight) {
        const progress = Math.max(0, Math.min(1, -rect.top / (rect.height * 0.85)));
        heroMedia.style.transform = `translate3d(0, ${progress * 48}px, 0) scale(1.08)`;
      }
      ticking = false;
    }

    window.addEventListener('scroll', () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }, { passive: true });

    update();
  }

  initScrollReveal();
  initHeroParallax();

  /* ── Shared fullscreen player for carousel videos ── */
  function initVideoLightbox() {
    const lightbox = document.getElementById('videoLightbox');
    const player = document.getElementById('videoLightboxPlayer');
    if (!lightbox || !player) return;

    const closeButtons = Array.from(lightbox.querySelectorAll('[data-video-lightbox-close]'));
    let returnFocus = null;

    function getVideoSource(video) {
      if (video.currentSrc) return video.currentSrc;
      if (video.getAttribute('src')) return video.getAttribute('src');
      const sources = Array.from(video.querySelectorAll('source[src]'));
      const mp4 = sources.find((source) => /mp4/i.test(source.type || source.src));
      return (mp4 || sources[0])?.src || '';
    }

    function closeLightbox() {
      player.pause();
      player.removeAttribute('src');
      player.removeAttribute('poster');
      player.load();
      lightbox.hidden = true;
      document.documentElement.classList.remove('video-lightbox-open');
      if (returnFocus) returnFocus.focus({ preventScroll: true });
      returnFocus = null;
    }

    function openLightbox(card, sourceVideo) {
      const source = getVideoSource(sourceVideo);
      if (!source) return;

      document.querySelectorAll('.community-video, .usage-video').forEach((video) => video.pause());
      returnFocus = card;
      if (!card.hasAttribute('tabindex')) card.setAttribute('tabindex', '0');
      player.src = source;
      if (sourceVideo.poster) player.poster = sourceVideo.poster;
      player.currentTime = 0;
      player.muted = false;
      player.loop = false;
      lightbox.hidden = false;
      document.documentElement.classList.add('video-lightbox-open');
      lightbox.querySelector('.video-lightbox__close').focus({ preventScroll: true });
      const playAttempt = player.play();
      if (playAttempt && typeof playAttempt.catch === 'function') playAttempt.catch(() => {});
    }

    document.addEventListener('click', (event) => {
      const card = event.target.closest('.video-card, .usage-card');
      if (!card || card.classList.contains('video-card--clone')) return;
      const sourceVideo = card.querySelector('.community-video, .usage-video');
      if (!sourceVideo) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      openLightbox(card, sourceVideo);
    }, true);

    closeButtons.forEach((button) => button.addEventListener('click', closeLightbox));
    document.addEventListener('keydown', (event) => {
      if (!lightbox.hidden && event.key === 'Escape') closeLightbox();
    });
  }

  initVideoLightbox();


  /* ── Community video carousel: infinite scroll + hover/tap play ── */
  function initCommunityCarousel() {
    const root = document.querySelector('.video-carousel');
    if (!root) return;

    const track = root.querySelector('.video-carousel-track');
    if (!track) return;

    const originals = Array.from(track.querySelectorAll('.video-card:not(.video-card--clone)'));
    const total = originals.length;
    if (!total) return;

    const CLONE_COUNT = 0;
    let isAdjusting = false;
    let scrollEndTimer;
    let scrollRaf = 0;

    for (let i = total - CLONE_COUNT; i < total; i += 1) {
      const clone = originals[i].cloneNode(true);
      clone.classList.add('video-card--clone');
      clone.setAttribute('aria-hidden', 'true');
      track.insertBefore(clone, track.firstChild);
    }
    for (let i = 0; i < CLONE_COUNT; i += 1) {
      const clone = originals[i].cloneNode(true);
      clone.classList.add('video-card--clone');
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    }

    function allCards() {
      return Array.from(track.querySelectorAll('.video-card'));
    }

    function getMetrics() {
      const cards = allCards();
      const card = cards[0];
      if (!card) return null;
      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 32;
      const stride = card.offsetWidth + gap;
      const realStart = CLONE_COUNT * stride;
      const realEnd = realStart + total * stride;
      return { cards, gap, stride, realStart, realEnd };
    }

    function jumpWithoutAnimation(fn) {
      isAdjusting = true;
      const prev = track.style.scrollBehavior;
      track.style.scrollBehavior = 'auto';
      fn();
      requestAnimationFrame(() => {
        track.style.scrollBehavior = prev || '';
        isAdjusting = false;
      });
    }

    function normalizeScroll() {
      if (isAdjusting) return;
      const metrics = getMetrics();
      if (!metrics) return;
      const { stride, realStart, realEnd } = metrics;
      const left = track.scrollLeft;
      if (left < realStart - stride * 0.25) {
        jumpWithoutAnimation(() => { track.scrollLeft = left + total * stride; });
      } else if (left >= realEnd - stride * 0.25) {
        jumpWithoutAnimation(() => { track.scrollLeft = left - total * stride; });
      }
    }

    function initScrollPosition() {
      const metrics = getMetrics();
      if (!metrics) return;
      track.scrollLeft = metrics.realStart;
    }

    function getRealIndex() {
      const metrics = getMetrics();
      if (!metrics) return 0;
      const center = track.scrollLeft + track.clientWidth / 2;
      let idx = Math.round((center - metrics.realStart - metrics.stride / 2) / metrics.stride);
      idx = ((idx % total) + total) % total;
      return idx;
    }

    function scrollToRealIndex(index, behavior) {
      const metrics = getMetrics();
      if (!metrics) return;
      const normalized = ((index % total) + total) % total;
      track.scrollTo({
        left: metrics.realStart + normalized * metrics.stride,
        behavior: behavior || 'smooth',
      });
    }

    const isTouch = !prefersReducedMotion && window.matchMedia('(hover: none) and (pointer: coarse)').matches;
    let sequenceIndex = null;

    function setVideoPosterState(video, card, visible) {
      const poster = video.getAttribute('poster');
      if (poster) {
        card.style.backgroundImage = `url("${poster.replace(/"/g, '%22')}")`;
        card.style.backgroundSize = 'cover';
        card.style.backgroundPosition = 'center';
      }
      card.classList.toggle('is-video-poster', visible);
    }

    function revealVideoAfterFirstFrame(video, card) {
      const reveal = () => {
        if (!video.paused && video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
          card.classList.remove('is-video-poster', 'is-video-fallback');
        }
      };

      if (typeof video.requestVideoFrameCallback === 'function') {
        video.requestVideoFrameCallback(reveal);
      } else {
        requestAnimationFrame(() => requestAnimationFrame(reveal));
      }
    }

    function playVideo(video, card) {
      video.muted = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      if (video.networkState === HTMLMediaElement.NETWORK_EMPTY) video.load();
      return video.play().then(() => {
        card.classList.remove('is-video-fallback');
        card.classList.add('is-playing');
        revealVideoAfterFirstFrame(video, card);
      }).catch(() => {
        card.classList.add('is-video-fallback');
        setVideoPosterState(video, card, true);
      });
    }

    function pauseVideo(video, card) {
      video.pause();
      video.currentTime = 0;
      card.classList.remove('is-playing');
      setVideoPosterState(video, card, true);
    }

    function playOnly(activeCard) {
      allCards().forEach((card) => {
        const video = card.querySelector('.community-video');
        if (!video) return;
        if (card === activeCard) playVideo(video, card);
        else pauseVideo(video, card);
      });
    }

    function syncCenteredVideo() {
      const metrics = getMetrics();
      if (!metrics) return;
      const centerX = track.scrollLeft + track.clientWidth / 2;
      let bestCard = null;
      let bestDist = Infinity;

      metrics.cards.forEach((card) => {
        if (card.classList.contains('video-card--clone')) return;
        const cardCenter = card.offsetLeft + card.offsetWidth / 2;
        const dist = Math.abs(cardCenter - centerX);
        if (dist < bestDist) {
          bestDist = dist;
          bestCard = card;
        }
      });

      if (bestCard) playOnly(bestCard);
    }

    track.addEventListener('scroll', () => {
      if (isAdjusting) return;
      cancelAnimationFrame(scrollRaf);
      scrollRaf = requestAnimationFrame(() => {
        clearTimeout(scrollEndTimer);
        scrollEndTimer = setTimeout(normalizeScroll, 80);
        if (isTouch) syncCenteredVideo();
      });
    }, { passive: true });

    window.addEventListener('resize', () => {
      clearTimeout(scrollEndTimer);
      scrollEndTimer = setTimeout(() => {
        const metrics = getMetrics();
        if (!metrics) return;
        const idx = getRealIndex();
        jumpWithoutAnimation(() => {
          track.scrollLeft = metrics.realStart + idx * metrics.stride;
        });
      }, 150);
    });

    requestAnimationFrame(initScrollPosition);

    if (prefersReducedMotion) return;

    function advancePlaybackOrder() {
      const nextIndex = sequenceIndex == null ? (getRealIndex() + 1) % total : (sequenceIndex + 1) % total;
      sequenceIndex = nextIndex;
      scrollToRealIndex(nextIndex, 'smooth');
      window.setTimeout(() => {
        const metrics = getMetrics();
        if (!metrics) return;
        const target = metrics.cards[CLONE_COUNT + nextIndex];
        if (target) playOnly(target);
      }, 320);
    }

    allCards().forEach((card) => {
      const video = card.querySelector('.community-video');
      if (!video) return;

      video.muted = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      setVideoPosterState(video, card, true);
      video.addEventListener('loadeddata', () => card.classList.remove('is-video-fallback'));
      video.addEventListener('error', () => {
        card.classList.add('is-video-fallback');
        setVideoPosterState(video, card, true);
      });

      video.addEventListener('ended', () => {
        if (sequenceIndex != null) advancePlaybackOrder();
      });

      if (isTouch) {
        card.addEventListener('click', () => {
          if (video.paused) {
            sequenceIndex = getRealIndex();
            video.loop = false;
            playOnly(card);
          } else {
            sequenceIndex = null;
            video.loop = true;
            pauseVideo(video, card);
          }
        });
      } else {
        card.addEventListener('mouseenter', () => {
          sequenceIndex = null;
          video.loop = true;
          playOnly(card);
        });
        card.addEventListener('mouseleave', () => {
          pauseVideo(video, card);
        });
        card.addEventListener('click', () => {
          sequenceIndex = getRealIndex();
          video.loop = false;
          playOnly(card);
        });
      }
    });
  }

  initCommunityCarousel();

  /* ── Usage scenario videos: hover (desktop) / carousel autoplay (mobile) ── */
  function initUsageVideos(root = document) {
    const cards = Array.from(root.querySelectorAll('.usage-card'));
    if (!cards.length) return;
    if (prefersReducedMotion) return;

    const isTouch = window.matchMedia('(hover: none) and (pointer: coarse)').matches;
    const usageGrid = root.querySelector('.usage-grid');
    const mobileCarouselMq = window.matchMedia('(max-width: 1024px)');
    const isUsageCarousel = Boolean(usageGrid && mobileCarouselMq.matches);

    let usageVideoUrls = {};
    const usageUrlsEl = root.querySelector('#usage-video-urls');
    if (usageUrlsEl) {
      try {
        usageVideoUrls = JSON.parse(usageUrlsEl.textContent);
      } catch (err) {
        usageVideoUrls = {};
      }
    }

    function getDeclaredUsageVideoSources(video) {
      const sources = [];
      const src = video.getAttribute('src');
      if (src) sources.push(src);

      video.querySelectorAll('source[src]').forEach((source) => {
        const sourceSrc = source.getAttribute('src');
        if (sourceSrc) sources.push(sourceSrc);
      });

      const dataSrc = video.getAttribute('data-src');
      if (dataSrc) sources.push(dataSrc);

      const key = video.getAttribute('data-usage-key');
      if (key && usageVideoUrls[key]) sources.push(usageVideoUrls[key]);

      return Array.from(new Set(sources));
    }

    function normalizeUsageVideoUrl(src) {
      if (!src) return '';
      try {
        return new URL(src, document.baseURI).href;
      } catch (error) {
        return src;
      }
    }

    function syncUsageVideoSource(video) {
      const declaredSources = getDeclaredUsageVideoSources(video);
      if (!declaredSources.length) return '';

      const normalizedDeclaredSources = declaredSources.map(normalizeUsageVideoUrl);
      const normalizedCurrentSrc = normalizeUsageVideoUrl(video.currentSrc);
      const currentSourceIsSelected = normalizedCurrentSrc && normalizedDeclaredSources.includes(normalizedCurrentSrc);

      if (!currentSourceIsSelected) {
        video.load();
      }

      return declaredSources[0];
    }

    function ensureUsageVideoReady(video) {
      const src = syncUsageVideoSource(video);
      if (!src) return Promise.reject(new Error('missing usage video src'));

      if (video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
        return Promise.resolve();
      }

      return new Promise((resolve, reject) => {
        const onReady = () => {
          cleanup();
          resolve();
        };
        const onError = () => {
          cleanup();
          reject(new Error('usage video load failed'));
        };
        const cleanup = () => {
          video.removeEventListener('canplay', onReady);
          video.removeEventListener('error', onError);
        };
        video.addEventListener('canplay', onReady, { once: true });
        video.addEventListener('error', onError, { once: true });
      });
    }

    function playUsageVideo(video, card) {
      return ensureUsageVideoReady(video).then(() => {
        video.muted = true;
        return video.play();
      }).then(() => {
        card.classList.add('is-playing');
        const reveal = () => {
          if (!video.paused && video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
            card.classList.remove('is-video-poster', 'is-video-fallback');
          }
        };
        if (typeof video.requestVideoFrameCallback === 'function') {
          video.requestVideoFrameCallback(reveal);
        } else {
          requestAnimationFrame(() => requestAnimationFrame(reveal));
        }
      }).catch(() => {
        const poster = video.getAttribute('poster');
        if (poster) card.style.backgroundImage = `url("${poster.replace(/"/g, '%22')}")`;
        card.classList.add('is-video-poster', 'is-video-fallback');
      });
    }

    function pauseUsageVideo(video, card) {
      video.pause();
      video.currentTime = 0;
      card.classList.remove('is-playing');
      const poster = video.getAttribute('poster');
      if (poster) {
        card.style.backgroundImage = `url("${poster.replace(/"/g, '%22')}")`;
        card.style.backgroundSize = 'cover';
        card.style.backgroundPosition = 'center';
      }
      card.classList.add('is-video-poster');
    }

    const playOnly = (activeCard) => {
      cards.forEach((card) => {
        const video = card.querySelector('.usage-video');
        if (!video) return;
        if (card === activeCard) playUsageVideo(video, card);
        else pauseUsageVideo(video, card);
      });
    };

    cards.forEach((card) => {
      const video = card.querySelector('.usage-video');
      if (!video) return;

      video.muted = true;
      video.loop = true;
      video.setAttribute('playsinline', '');
      syncUsageVideoSource(video);

      if (document.documentElement.classList.contains('shopify-design-mode') || document.body.classList.contains('shopify-design-mode')) {
        playUsageVideo(video, card);
      }

      if (!isTouch) {
        const playCard = () => playOnly(card);
        const pauseCard = () => pauseUsageVideo(video, card);
        card.addEventListener('mouseenter', playCard);
        card.addEventListener('mouseleave', pauseCard);
      } else if (!isUsageCarousel) {
        const playCard = () => playOnly(card);
        const pauseCard = () => pauseUsageVideo(video, card);
        card.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'touch' || event.pointerType === 'pen') playCard();
        });
        card.addEventListener('pointerup', pauseCard);
        card.addEventListener('pointercancel', pauseCard);
        card.addEventListener('pointerleave', (event) => {
          if (event.pointerType === 'touch' || event.pointerType === 'pen') pauseCard();
        });
      }
    });

    if (isUsageCarousel && usageGrid) {
      let scrollEndTimer;
      let scrollRaf = 0;

      const syncCenteredVideo = () => {
        const gridRect = usageGrid.getBoundingClientRect();
        const centerX = gridRect.left + gridRect.width / 2;
        let bestCard = null;
        let bestDist = Infinity;

        cards.forEach((card) => {
          const rect = card.getBoundingClientRect();
          if (rect.right < gridRect.left || rect.left > gridRect.right) return;
          const dist = Math.abs(rect.left + rect.width / 2 - centerX);
          if (dist < bestDist) {
            bestDist = dist;
            bestCard = card;
          }
        });

        if (bestCard) playOnly(bestCard);
      };

      const scheduleSync = (delay = 0) => {
        clearTimeout(scrollEndTimer);
        scrollEndTimer = setTimeout(syncCenteredVideo, delay);
      };

      usageGrid.addEventListener('scroll', () => {
        cancelAnimationFrame(scrollRaf);
        scrollRaf = requestAnimationFrame(() => scheduleSync(80));
      }, { passive: true });

      usageGrid.addEventListener('scrollend', syncCenteredVideo, { passive: true });

      mobileCarouselMq.addEventListener('change', () => {
        if (mobileCarouselMq.matches) syncCenteredVideo();
      });

      window.addEventListener('resize', () => scheduleSync(100), { passive: true });

      syncCenteredVideo();
    }
  }

  initUsageVideos();

  if ('IntersectionObserver' in window && !prefersReducedMotion) {
    const counterObs = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          counterObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('[data-count]').forEach((el) => {
      const rect = el.getBoundingClientRect();
      const inView = rect.top < window.innerHeight * 0.92 && rect.bottom > 0;
      if (inView) {
        animateCounter(el);
      } else {
        counterObs.observe(el);
      }
    });
  } else if (prefersReducedMotion) {
    document.querySelectorAll('[data-count]').forEach((el) => el.classList.add('is-counted'));
  }
})();
